export default __webpack_public_path__ + "static/media/tab04-m_title02.456b6e43.png";